/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalRequest } from './PortalRequest';
import {
    PortalRequestFromJSON,
    PortalRequestFromJSONTyped,
    PortalRequestToJSON,
    PortalRequestToJSONTyped,
} from './PortalRequest';

/**
 * 
 * @export
 * @interface PortalRequestList
 */
export interface PortalRequestList {
    /**
     * 
     */
    requests: Array<PortalRequest>;
}

/**
 * Check if a given object implements the PortalRequestList interface.
 */
export function instanceOfPortalRequestList(value: object): value is PortalRequestList {
    if (!('requests' in value) || value['requests'] === undefined) return false;
    return true;
}

export function PortalRequestListFromJSON(json: any): PortalRequestList {
    return PortalRequestListFromJSONTyped(json, false);
}

export function PortalRequestListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalRequestList {
    if (json == null) {
        return json;
    }
    return {
        
        'requests': ((json['requests'] as Array<any>).map(PortalRequestFromJSON)),
    };
}

export function PortalRequestListToJSON(json: any): PortalRequestList {
    return PortalRequestListToJSONTyped(json, false);
}

export function PortalRequestListToJSONTyped(value?: PortalRequestList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requests': ((value['requests'] as Array<any>).map(PortalRequestToJSON)),
    };
}

